var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRebateUrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.5H1.5V1.5H5V0.5H1.5C0.945 0.5 0.5 0.95 0.5 1.5V8.5C0.5 9.05 0.945 9.5 1.5 9.5H8.5C9.05 9.5 9.5 9.05 9.5 8.5V5H8.5V8.5ZM6 0.5V1.5H7.795L2.88 6.415L3.585 7.12L8.5 2.205V4H9.5V0.5H6Z",
    fill: "#273137"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRebateUrl);
export default __webpack_public_path__ + "static/media/iconRebateUrl.8c293c4ace62ba9338c7d1800d74d5a8.svg";
export { ForwardRef as ReactComponent };